import { getDeviceOS } from 'src/utils/utils'
import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'
import { useSetAtom } from 'jotai'
import { downloadAppModalAtom } from 'src/atoms/downloadAppModal.atom'
import { CuiCheckbox, CuiMealCardLoading } from 'front-lib'
import { useSetUserDownloadApp } from 'src/hooks/useSetUserDownloadApp'

interface DownloadAppStepProps {
  readonly completed: boolean
  readonly enabled: boolean
}

export function DownloadAppStep({
  completed,
  enabled
}: Readonly<DownloadAppStepProps>) {
  const setIsDownloadModalOpen = useSetAtom(downloadAppModalAtom)
  const { setUserDownloadApp, loading } = useSetUserDownloadApp()

  function handleDownloadClick() {
    const deviceOS = getDeviceOS()
    if (deviceOS === 'iOS') {
      window.location.href =
        'https://apps.apple.com/us/app/cookunity/id6636491709'
    } else if (deviceOS === 'Android') {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.cookunity.app'
    } else {
      setIsDownloadModalOpen({ isOpen: true })
    }
  }

  function handleCheckboxChange(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    setUserDownloadApp({ active: !completed })
  }

  return loading ? (
    <CuiMealCardLoading />
  ) : (
    <OnboardingStep
      title="Get the CookUnity app"
      description="Manage orders, track deliveries, rate meals, and more—right from your phone."
      status={getStepStatus(completed, enabled)}
      icon="download"
      action={{
        label: 'Get the App',
        onClick: handleDownloadClick
      }}>
      <button onClick={handleCheckboxChange}>
        <CuiCheckbox checked={completed} id="download-app-checkbox">
          Mark as complete.
        </CuiCheckbox>
      </button>
    </OnboardingStep>
  )
}
